export const widthKeys = ['width', 'maxWidth', 'minWidth'];
